import {Component, Host, h, Element, Prop, Listen, Event, EventEmitter, Watch, Method} from '@stencil/core';
import {computePosition, flip, offset, shift, size} from '@floating-ui/dom';
import {platform} from '@floating-ui/dom';
import {offsetParent} from 'composed-offset-position';

@Component({
  tag: 'z3-dropdown',
  styleUrl: 'z3-dropdown.css',
  shadow: false,
})
export class Z3Dropdown {
  @Element() host: HTMLElement;

  @Prop( {mutable: true, reflect: true} ) open: boolean = false;
  @Prop( {mutable: true, reflect: true} ) autowidth: boolean = true;
  @Prop( {mutable: true, reflect: true} ) label: string = '';
  @Prop( {mutable: true, reflect: true} ) closeonclickinside: boolean = false;

  dropdownWrapper!: HTMLDivElement;
  dropdownTrigger!: HTMLButtonElement;

  /**
   * close dropdown on escape click
   */
  @Listen('keydown')
  handleKeyDown(event: KeyboardEvent){
    if (event.key === 'Escape'){
      this.open = false
    }
  }

  /**
   * close dropdown on outside click
   */
  @Listen('click', { target: 'window' })
  handleClick(event: MouseEvent) {
    const path = Array.from(event.composedPath());

    if (this.closeonclickinside) {
      if (path.includes(this.dropdownWrapper)) {
        this.open = false
        return;
      }
    }
    if (!path.includes(this.host)) {
      this.open = false
      return
    }
  }

  @Watch('open')
  watchPropHandler(newValue: boolean) {
    this.openEvent.emit(newValue)
  }

  @Event({
    eventName: 'open',
    composed: true,
    cancelable: true,
    bubbles: true,
  }) openEvent!: EventEmitter;

  @Method()
  async close() {
    this.open = false
  }

  connectedCallback() {
    this.host.classList.add('loaded')
  }

  handledropdownClick() {
    this.open = !this.open
  }

  componentDidRender(){
    // create Dropdown
    const trigger = this.dropdownTrigger as HTMLElement
    const tooltip = this.dropdownWrapper as HTMLElement
    // createPopper(trigger, tooltip, {});
    // computePosition(trigger, tooltip, {})
    computePosition(trigger, tooltip, {
      platform: {
        ...platform,
        getOffsetParent: (element) =>
          platform.getOffsetParent(element, offsetParent),
      },
      placement: 'bottom',
      // Try removing the middleware. The dropdown will
      // overflow the boundary's edge and get clipped!
      middleware: [
        offset(0),
        flip(),
        shift({padding: 15}),
        size({
          apply({ availableHeight }) {
            Object.assign(tooltip.style, {
              maxHeight: `${Math.max(0, availableHeight)}px`
            });
          },
          padding: 96
        })
      ]
    }).then(({ x, y }) => {
      Object.assign(tooltip.style, {
        top: `${y}px`,
        left: `${x}px`
      });
    });

    // set minWidth of dropdown by largest Option
    if (this.autowidth) {
      let optionWrapperWidth = this.dropdownWrapper.offsetWidth
      if (optionWrapperWidth > 0) {
        this.dropdownTrigger.style.width = optionWrapperWidth + 'px'
      }
    }
  }

  handleSlotChange () {}

  render() {
    return (
      <Host>
        <button
          part="button"
          class={{
            'dropdown__trigger': true,
            'open': this.open,
          }}
          ref={(el) => this.dropdownTrigger = el as HTMLButtonElement}
          onClick={() => this.handledropdownClick()}>
          <span class="dropdown__trigger__text">
            {this.label}
            <slot name="label"></slot>
          </span>
          <svg xmlns="http://www.w3.org/2000/svg" width="14.12" height="8.44" viewBox="0 0 14.12 8.44">
           <polyline points=".37 .34 7.06 7.7 13.75 .34" fill="none" stroke="currentColor" />
          </svg>
        </button>
        <div
          part="dropdown"
          ref={(el) => this.dropdownWrapper = el as HTMLDivElement}
          class={{
           'dropdown__dropdown': true,
           'open': this.open,
        }}>
          <slot onSlotchange={this.handleSlotChange}></slot>
        </div>
      </Host>
    );
  }

}
